export type FeedUrl = {
    path: string;
    title: string;
};

export const getFeedUrlForPath = (path = '', title = ''): Array<FeedUrl> => {
    const titleMatch = path.match('^(?!/program$|/kanaler$|/kategori$)(\\/[\\w-]+)(\\?.+)?$');
    const genreMatch = path.match('^(\\/kategori\\/[\\w-]+)(\\?.+)?$');

    if (path === '/') {
        return [
            {
                path: '',
                title: '',
            },
        ];
    }
    if (titleMatch !== null) {
        return [
            {
                path: titleMatch[1],
                title: title ? `Senaste avsnitten av ${title}` : '',
            },
        ];
    }
    if (genreMatch !== null) {
        return [
            {
                path: genreMatch[1],
                title: title ? `Senaste avsnitten från SVT inom ämnet ${title}` : '',
            },
            {
                path: `${genreMatch[1]}/klipp`,
                title: title ? `Senaste klippen från SVT inom ämnet ${title}` : '',
            },
        ];
    }

    return [];
};
